import {
  Directive,
  Input,
  OnChanges,
  Renderer2,
  ElementRef,
} from '@angular/core';

@Directive({
    selector: '[titleIfTruncated]',
    standalone: false
})
export class TitleIfTruncatedDirective implements OnChanges {
  @Input('titleIfTruncated') text: string | null = null;
  @Input() maxLength: number = 30;

  constructor(private el: ElementRef, private renderer: Renderer2) {}

  ngOnChanges() {
    if (!this.text) {
      this.renderer.removeAttribute(this.el.nativeElement, 'title');
      return;
    }

    if (this.text.length > this.maxLength) {
      this.renderer.setAttribute(this.el.nativeElement, 'title', this.text);
    } else {
      this.renderer.removeAttribute(this.el.nativeElement, 'title');
    }
  }
}